import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import isEmpty from 'lodash/isEmpty';
import { useParams, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { profileInfoSelector } from 'selectors/expert-profile';
import { rootSiteSelector, siteFromRootSiteSelector } from 'selectors/root-site';
import { useTrackPageView } from 'hooks/analytics';
import useFavicon from 'hooks/favicon';

const HeadTags = ({ title: containerTitle }) => {
  const { siteSlug, expertSlug } = useParams();
  const location = useLocation();

  const {
    siteName,
    reducedSearchEngineVisibility: reducedSearchEngineForSite,

    siteLogo,
  } = useSelector(siteSlug ? siteFromRootSiteSelector(siteSlug) : rootSiteSelector);
  const { name: expertName, reducedSearchEngineVisibility: reducedSearchEngineForExpert } =
    useSelector(profileInfoSelector);

  const headTitle = useMemo(
    () => [siteName, containerTitle, expertSlug && expertName].filter((value) => !isEmpty(value)).join(' | '),
    [containerTitle, expertName, expertSlug, siteName],
  );

  const isPreventedSearchEngine = expertSlug ? reducedSearchEngineForExpert : reducedSearchEngineForSite;

  useTrackPageView(location.pathname, headTitle);

  useFavicon(siteLogo?.favicons, !!siteSlug);

  const canonicalUrl = `${window.location.origin}${location.pathname}`;

  return (
    <Helmet>
      <title>{headTitle}</title>
      <link rel='canonical' href={canonicalUrl} />
      <meta property='og:url' content={canonicalUrl} />
      {isPreventedSearchEngine && <meta name='robots' content='noindex, nofollow' />}
      <meta property='og:title' content={headTitle} />
      <meta property='og:image' content={siteLogo?.imageUrl} />
    </Helmet>
  );
};

HeadTags.propTypes = {
  title: PropTypes.string,
  privateRoute: PropTypes.bool,
};

export default HeadTags;
